import {useMemo} from 'react';

import {
  type GetRunsForMoveGroupsQuery,
  type GetRunsForMoveGroupsQueryVariables,
} from '../../../generated/graphql';
import {useQuery} from '../../../state/graphql/apolloWithAbort';
import {combinedFilter} from '../../../state/graphql/runSelectorQuery';
import {type GroupSelectionState} from '../../../util/selectionmanager';
import {GET_RUNS_FOR_MOVE_GROUPS} from './GetRunsForMoveGroups.query';

type UseSelectedRunsOpts = {
  entityName: string;
  projectName: string;
  groupTempSelection: GroupSelectionState;
  skip: boolean;
};

type RunDrawerRun = NonNullable<
  NonNullable<GetRunsForMoveGroupsQuery['project']>['runs']
>['edges'][number]['node'];

/**
 * Determines which literal runs have been selected based on what rows in the
 * table have been checked. The query is only run when the drawer is opened,
 * which prevents the query from being invoked any time the user selects or
 * unselects a run.
 */
export function useSelectedRuns({
  entityName,
  projectName,
  groupTempSelection,
  skip,
}: UseSelectedRunsOpts): {loading: boolean; runs: RunDrawerRun[]} {
  const {data, loading} = useQuery<
    GetRunsForMoveGroupsQuery,
    GetRunsForMoveGroupsQueryVariables
  >(GET_RUNS_FOR_MOVE_GROUPS, {
    variables: {
      entityName,
      projectName,
      filters: JSON.stringify(combinedFilter(undefined, groupTempSelection)),
    },
    skip,
  });

  const runs = useMemo(() => {
    if (loading) {
      return [];
    }
    return data?.project?.runs?.edges.map(e => e.node) || [];
  }, [data, loading]);

  return {loading, runs};
}
